import { connect } from "vuex-connect";
import { SaleContractRegister } from "../../components";

export default connect({
  actionsToProps: {
    postContract: (dispatch, value) => dispatch("sale/postContractSale", value)
  }
})(SaleContractRegister.extendOptions.name, SaleContractRegister);
